package er.prateek.crossly.firebase

/** Wraps Firebase Crashlytics. No `setUserId` -- v1 has no auth, see docs/PLAN.md. */
interface CrashReporter {
    fun recordException(throwable: Throwable)
    fun log(message: String)
    fun setCustomKey(key: String, value: String)
}

object NoOpCrashReporter : CrashReporter {
    override fun recordException(throwable: Throwable) = Unit
    override fun log(message: String) = Unit
    override fun setCustomKey(key: String, value: String) = Unit
}
